var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('div',{directives:[{name:"swiper",rawName:"v-swiper:mySwiper",value:(_vm.swiperOption),expression:"swiperOption",arg:"mySwiper"}]},[_c('div',{staticClass:"pagination-list swiper-wrapper"},_vm._l((_vm.visible_list),function(item){return _c('div',{key:item.index,class:[
          'swiper-slide pagination-item',
          {
            is_active: item.is_active,
            is_available: item.is_available,
            is_done: item.is_done,
            is_skipped: item.is_skipped
          }
        ],attrs:{"disabled":_vm.disabled || item.disabled},on:{"click":function($event){return _vm.change_index(item.index)}}},[_vm._v("\n        "+_vm._s(item.index + 1)+"\n      ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }